import { LitElement, html, css, unsafeCSS } from 'lit-element';

import stratusStatsCardStyle from './stratus-stats-card.scss';
import CardComponentType from '../../enums/card-component-type';
import HorizontalBarMeter from '../horizontal-bar-meter/horizontal-bar-meter';
import { NumberComparisonTable } from '../number-comparison-table/number-comparison-table';
import GaugeChart from '../gauge-chart/gauge-chart';
import { StratusStatsCardTemplateModel } from '../../models/components/StratusStatsCardTemplateModel';
import { StratusStatsCardComponentTemplateModel } from '../../models/components/StratusStatsCardComponentTemplateModel';
import { PlayerBreakdownTable } from '../player-breakdown-table/player-breakdown-table';
import { TeamBreakdownTable } from '../team-breakdown-table/team-breakdown-table';
import { reportsApi } from '../../api/reportsApi';
import { StandardValueDisplay } from '../standard-value-display/standard-value-display';

export class StratusStatsCard extends LitElement {
    private _cardTemplate: StratusStatsCardTemplateModel;
    private _removeComponentsPadding: boolean;
    private _playlistClickThrough: boolean;
    private _reportsApi: reportsApi;
    private _userId: string;
    private _reportId: string;
    private _matchId: string;
    private _seasonId: string;

    constructor(cardTemplate: StratusStatsCardTemplateModel,
        removeComponentsPadding: boolean,
        reportsApi: reportsApi,
        playlistClickThrough: boolean,
        userId: string,
        reportId: string,
        matchId: string,
        seasonId: string) {
        super();

        this._cardTemplate = cardTemplate;
        this._removeComponentsPadding = removeComponentsPadding;
        this._playlistClickThrough = playlistClickThrough;
        this._reportsApi = reportsApi;

        this._userId = userId;
        this._reportId = reportId;
        this._matchId = matchId;
        this._seasonId = seasonId;
    }

    static get styles() {
        return [
            css`${unsafeCSS(stratusStatsCardStyle)}`
        ]
    }

    render() {
        return [
            html`<div class="stats-container">
                ${(this._cardTemplate.heading ? html`<h5>${this._cardTemplate.heading}</h5>` : '')}
                <div class="components ${(this._removeComponentsPadding ? "no-gutters" : "")}">
                    ${this._cardTemplate.content.map((component) => html`${this.buildComponent(component)}`)}
                </div>
            <div>`
        ]
    }

    async metricClick(event: Event, metricId: string, teamId: string, playerId: string, name: string) {
        if (this._playlistClickThrough) {
            let playlistId = await this._reportsApi.GetMetricPlaylist(this._reportId, metricId, this._seasonId ?? "", this._matchId ?? "", teamId, playerId, name)

            if (!playlistId)
                return;

            window.open(`/Playlists/Playlist/PlaylistViewer?playlistId=${playlistId}&isTemporary=true`, "_blank");
        }
    }

    buildComponent(cardComponentTemplate: StratusStatsCardComponentTemplateModel) {
        let component = null;

        switch (cardComponentTemplate.type) {
            case CardComponentType.HorizontalBarMeterMiddleStart:
                component = html`${new HorizontalBarMeter(cardComponentTemplate, true, this._playlistClickThrough, ((event, metricId, teamId, name) => this.metricClick(event, metricId, teamId, "", name)))}`;
                break;
            case CardComponentType.HorizontalBarMeterEndStart:
                component = html`${new HorizontalBarMeter(cardComponentTemplate, false, this._playlistClickThrough, ((event, metricId, teamId, name) => this.metricClick(event, metricId, teamId, "", name)))}`;
                break;
            case CardComponentType.NumberComparisonTable:
                component = html`${new NumberComparisonTable(cardComponentTemplate, this._playlistClickThrough, ((event, metricId, teamId, name) => this.metricClick(event, metricId, teamId, "", name)))}`;
                break;
            case CardComponentType.GaugeChart:
                component = html`${new GaugeChart(cardComponentTemplate, this._playlistClickThrough, ((event, metricId, teamId, name) => this.metricClick(event, metricId, teamId, "", name)))}`;
                break;
            case CardComponentType.PlayerBreakdownTable:
                //do conditional formatting here                
                component = html`${new PlayerBreakdownTable(cardComponentTemplate, this._cardTemplate.tableHeaders, this._playlistClickThrough, ((event, metricId, teamId, playerId, name) => this.metricClick(event, metricId, teamId, playerId, name)))}`;
                break;
            case CardComponentType.TeamBreakdownTable:
                component = html`${new TeamBreakdownTable(cardComponentTemplate, this._cardTemplate.tableHeaders, this._playlistClickThrough, ((event, metricId, teamId, name) => this.metricClick(event, metricId, teamId, "", name)))}`;
                break;
            case CardComponentType.StandardValueDisplay:
                component = html`${new StandardValueDisplay(cardComponentTemplate, this._playlistClickThrough, ((event, metricId, name) => this.metricClick(event, metricId, "", "", name)))}`;
                break;
            default:
                component = html``;
                break;
        }

        return component;
    }
}

window.customElements.define('stratus-stats-card', StratusStatsCard as any);